export const RALPHS_COMPANY_NAME = "Ralphs";
export const DEFAULT_RALPHS_LOCATION_ID = "70300738";

export const RALPHS_COMPANY_FALLBACK = Object.freeze({
  name: RALPHS_COMPANY_NAME,
});
